module.exports = __webpack_public_path__ + "static/media/restaurant6.c54c5a7b.jpg";